import { useEffect, useState } from 'react'

import { API_URL } from '@f-fertighaus/applications/Next/api/url'
import { APIResponse } from '@f-fertighaus/applications/Next/types/APIResponse'
import { SimilarHouse as SimilarHouseType } from '@f-fertighaus/applications/Next/types/similarHousesResponse'
import { client } from '@f-fertighaus/applications/Next/utils/client'

type SimilarHousesState = {
  status: 'idle' | 'loading' | 'houseNid-missing' | 'success' | 'error'
  data: null | SimilarHouseType[]
  error: null | Error
}

export const useSimilarHousesData = (houseNid?: string) => {
  const [state, setState] = useState<SimilarHousesState>({
    status: 'idle',
    data: null,
    error: null
  })

  useEffect(() => {
    let fetchInProgress = true
    setState(prevState => ({ ...prevState, status: 'loading' }))
    if (!houseNid) {
      setState(prevState => ({ ...prevState, status: 'houseNid-missing' }))
      return
    }

    if (fetchInProgress) {
      client<APIResponse<SimilarHouseType>>(API_URL.similarHouses(houseNid))
        .then(data =>
          setState(prevState => ({
            ...prevState,
            status: 'success',
            data: data.results
          }))
        )
        .catch(error =>
          setState(prevState => ({ ...prevState, status: 'error', error }))
        )
    }

    return () => {
      fetchInProgress = false
    }
  }, [houseNid])

  return state
}
